import React from 'react'
import { FlyOutStorefrontMetricsWrapper } from '../FlyOutStorefrontMetricsWrapper/FlyOutStorefrontMetricsWrapper'
import { faArrowPointer } from '@fortawesome/free-solid-svg-icons'
import { useStyles } from './TableAndConversionFunnel.styles'
import { TableViewClicksAndSubmissions } from './TableViewClicksAndSubmissions/TableViewClicksAndSubmissions'
import { MetricsData } from '../../../modules/storefrontMetrics/reducer'
import { faFilterCircleDollar } from '@fortawesome/pro-duotone-svg-icons'
import { getFormattedLabel } from '../FlyOutImpressions/FlyOutImpressions'
import { FunnelChart } from '@labrav/react-components'
export type TableAndConversionFunnelProps = {
  metricsData: MetricsData
}
export const TableAndConversionFunnel: React.FC<
  TableAndConversionFunnelProps
> = ({ metricsData }) => {
  const { classes } = useStyles()
  const data = metricsData.impressionCount
    .filter(item =>
      [
        'total_impression',
        'unique_impression',
        'unique_button_clicked',
        // 'Unique_form_submissions',
        // 'clicks',
        'form_submission',
        'converted',
      ].includes(item.key as string)
    )
    .map(item => {
      return {
        value: item.totalCount as number,
        category: getFormattedLabel(item.key as string),
      }
    })

  return (
    <div className={classes.rootWrapper}>
      <div className={classes.root} data-testid="table-funnel-wrapper">
        <div className={classes.content}>
          <div className={classes.wrapperWidth} data-testid="table-wrapper">
            <FlyOutStorefrontMetricsWrapper
              children={
                <TableViewClicksAndSubmissions
                  buttonsData={metricsData.buttonRecords}
                />
              }
              heading="Clicks and form submissions"
              icon={faArrowPointer}
              infoTooltip={'Clicks and form submissions'}
              padding={'0px'}
            />
          </div>
        </div>
      </div>
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.wrapperWidth} data-testid="funnel-wrapper">
            <FlyOutStorefrontMetricsWrapper
              children={
                <>
                  <div className={classes.funnel}></div>
                  {data.length > 0 && (
                    <FunnelChart
                      data={data}
                      showTooltip={true}
                      height="250px"
                      labelWrapperWidth={100}
                    />
                  )}
                </>
              }
              heading="Conversion funnel"
              icon={faFilterCircleDollar}
              infoTooltip={'Conversion funnel'}
              padding={'0px'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
